import { ReactNode, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./ControlsPanel.scss";

type Props = {
  children?: ReactNode;
  title?: string;
  defaultOpen?: boolean;
};

const ControlsPanel: React.FC<Props> = ({
  children,
  title = "Controles",
  defaultOpen = true,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <motion.div
      className="controls-panel"
      initial={{ opacity: 0, y: -8, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
    >
      <motion.button
        type="button"
        className="controls-panel__trigger"
        onClick={() => setOpen((v) => !v)}
        whileHover={{ background: "rgba(255,255,255,0.06)" }}
   
      >
        <span>{title}</span>
        <motion.span
          className="controls-panel__chevron"
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
        >
          ▾
        </motion.span>
      </motion.button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="controls-panel-body"
            className="controls-panel__body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <div className="controls-panel__content">
              {children ?? (
                <div className="controls-panel__placeholder">em breve</div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ControlsPanel;
